import { useState, useCallback } from 'react';
import createInputChangeHandler from 'hooks/util/createInputChangeHandler';

export default function useInput() {
  const defaultValue =
    arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  const _useState = useState(defaultValue),
    value = _useState[0],
    setValue = _useState[1];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setter = useCallback(createInputChangeHandler(setValue), []);

  return [value, setter];
}
